import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './GradingSystemSection.css';
import '../common-styles.css';

// Import grading system image
import gradingSystemImage from '../../assets/images/grading-system.png';

const GradingSystemSection: React.FC = () => {
  return (
    <section className="section grading-system-section">
      <Container>
        <Row className="align-items-center">
          {/* Left Content */}
          <Col lg={6} md={6} className="grading-content">
            <div className="grading-badge">GRADING SYSTEM</div>
            <h2 className="section-title">
              Precision <span className="section-title-highlight">You Can Trust.</span>
            </h2>
            <p className="grading-description">
              At SunDiam, we uphold the highest standards of diamond grading by strictly adhering to globally recognized systems such as GIA, IGI, and HRD. Guided primarily by GIA protocols, our grading process ensures each diamond is assessed with consistency, precision, and objectivity. Supported by skilled experts and modern tools, we deliver verified quality that meets international benchmarks—giving clients complete confidence in every stone's authenticity and brilliance.
            </p>
            <Link to="/grading" style={{ textDecoration: 'none' }}>
              <Button className="section-btn">
                <span className="btn-content">
                  Learn More About Grading System <i className="fas fa-arrow-right btn-arrow-diagonal" />
                </span>
              </Button>
            </Link>
          </Col>

          {/* Right Image */}
          <Col lg={6} md={6} className="grading-image-col">
            <div className="grading-image-container">
              <img 
                src={gradingSystemImage} 
                alt="Diamond Grading System" 
                className="grading-image"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default GradingSystemSection;
